import type { IStyleSheetContext } from "styled-components/dist/models/StyleSheetManager";
import isPropValid from "@emotion/is-prop-valid";

/**
 * Since styled-components v6 'shouldForwardProp'(automatic prop filtering) is no longer provided by default.
 * As we haven't migrated our styling yet to use transient props ($prefix),
 * we keep using the v5 behavior by adding this in the StyleSheetManager.
 * Reference: https://styled-components.com/docs/faqs#shouldforwardprop-is-no-longer-provided-by-default
 */
export const shouldForwardProp: undefined | IStyleSheetContext["shouldForwardProp"] = (propName, target) => {
    if (typeof target === "string") {
        // For HTML elements, forward the prop if it is a valid HTML attribute
        return isPropValid(propName);
    }
    // For other elements, forward all props
    return true;
};
